<template>
  <ux-form
    ref="form"
    :data="formData"
    :rules="rules"
    width="440px"
    :colon="true"
    label-width="70px"
    data-automation="addUser"
  >
    <ux-form-item :label="$t('HT.addLimit.type')" prop="type">
      <ux-select v-model.trim()="formData.type" :options="$opt.messageType" disabled></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.apiStepOne.remark')" start prop="memo">
      <ux-input
        v-model.trim()="formData.memo"
        type="textarea"
        show-word-limit
        :maxlength="100"
        resize="none"
        :autosize="{ minRows: 3, maxRows: 6 }"
      ></ux-input>
    </ux-form-item>
    <header class="currency_header">{{ $t('HT.changeCurrency.default') }}</header>
    <ux-form-item :label="$t('HT.addLimit.minute')" prop="minute">
      <ux-input
        v-model.trim()="formData.minute"
        :maxlength="4"
        :placeholder="$t('HT.changeCurrency.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLimit.day')" prop="day">
      <ux-input
        v-model.trim()="formData.day"
        :maxlength="4"
        :placeholder="$t('HT.changeCurrency.placeholder')"
      ></ux-input>
    </ux-form-item>
    <header class="currency_header">{{ $t('HT.changeCurrency.vip') }}</header>
    <ux-form-item :label="$t('HT.addLimit.minute')" prop="vip_minute">
      <ux-input
        v-model.trim()="formData.vip_minute"
        :maxlength="4"
        :placeholder="$t('HT.changeCurrency.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLimit.day')" prop="vip_day">
      <ux-input
        v-model.trim()="formData.vip_day"
        :maxlength="4"
        :placeholder="$t('HT.changeCurrency.placeholder')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          type: '', //消息类型
          remark: '', //描述
          minute: '', //默认号码每分钟限制
          day: '', //默认号码每日限制
          vip_minute: '', //VIP号码每分钟限制
          vip_day: '' //VIP每日限制
        };
      }
    }
  },
  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.currency()
    };
  }
};
</script>

<style lang="css">
.currency_header {
  font-weight: 600;
  font-size: 14px;
  margin-left: -25px;
  margin-bottom: 8px;
}
</style>
